<template>
  <FormCard
    :title="$t('incidentForm.chooseVerification')"
    :icon="false"
  >
    <div class="flex justify-center">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
        <button
          @click="selectMethod('phone')"
          class="auth-method-card group"
          :class="{ 'active': selectedMethod === 'phone' }"
        >
          <div class="flex flex-col items-center justify-center p-4">
            <div class="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center mb-2 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="text-lg font-bold mb-1 text-gray-900">{{ $t('incidentForm.phoneVerification') }}</h3>
            <p class="text-gray-600 text-center text-xs">{{ $t('incidentForm.phoneVerificationDesc') }}</p>
          </div>
        </button>

        <button
          @click="selectMethod('email')"
          class="auth-method-card group"
          :class="{ 'active': selectedMethod === 'email' }"
        >
          <div class="flex flex-col items-center justify-center p-4">
            <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-full flex items-center justify-center mb-2 shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="text-lg font-bold mb-1 text-gray-900">{{ $t('incidentForm.emailVerification') }}</h3>
            <p class="text-gray-600 text-center text-xs">{{ $t('incidentForm.emailVerificationDesc') }}</p>
          </div>
        </button>
      </div>
    </div>
  </FormCard>
</template>

<script>
import FormCard from '../ui/FormCard.vue';

export default {
  name: 'AuthMethodSelection',
  components: { FormCard },
  props: {
    selectedMethod: { type: String, default: null }
  },
  emits: ['select', 'continue'],
  methods: {
    selectMethod(method) {
      this.$emit('select', method);
      // Auto-advance to next step
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit('continue');
        }, 300);
      });
    }
  }
}
</script>

<style scoped>
.auth-method-card {
  @apply bg-white border-2 border-gray-200 rounded-xl cursor-pointer
         transition-all duration-300 hover:border-blue-500 hover:shadow-lg
         relative overflow-hidden hover:scale-[1.02];
}

.auth-method-card.active {
  @apply border-blue-500 bg-blue-50/50 shadow-lg shadow-blue-500/20;
}
</style>
